import vacationRental from '~/utils/jsonLd/vacationRental'
import type { ItemList } from '~/types/json-ld/ItemList'
import type { SolrResultItemDTO } from '~/types/TypesFromPortalBackend'

const useJsonLdItemListOfVacationRentals = () => {
  const productsListState = useState<SolrResultItemDTO[]>(() => [])

  const setProductsList = (productsList: SolrResultItemDTO[]) => {
    if (!productsList) {
      productsListState.value = []
      return
    }

    productsListState.value = productsList
  }

  const getAssembledObject = (): ItemList | null => {
    if (productsListState.value.length === 0) {
      return null
    }

    return {
      '@type': 'ItemList',
      itemListElement: productsListState.value.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: vacationRental(product)
      }))
    }
  }

  return {
    setProductsList,
    getAssembledObject
  }
}
export default useJsonLdItemListOfVacationRentals
